export default __webpack_public_path__ + "static/media/ads.b53cb6d0.jpg";